export default __webpack_public_path__ + "static/media/cif-lc.78dcd196.svg";